"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolTipIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var ToolTipIcon = function ToolTipIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 1.66669C5.39984 1.66669 1.6665 5.40002 1.6665 10C1.6665 14.6 5.39984 18.3334 9.99984 18.3334C14.5998 18.3334 18.3332 14.6 18.3332 10C18.3332 5.40002 14.5998 1.66669 9.99984 1.66669ZM9.1665 14.1667V9.16669H10.8332V14.1667H9.1665ZM9.1665 5.83335V7.50002H10.8332V5.83335H9.1665Z",
    fill: "#75767A"
  }));
};

exports.ToolTipIcon = ToolTipIcon;